import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import {
  AgentEndpoints,
  type CommonResponse,
  type RawAxiosHeaders,
  RequestMethods,
  useRequest,
} from '@shared/index';

export const useSubmitProfileEdit = (request?: FormData) => {
  const queryClient = useQueryClient();
  const headers: RawAxiosHeaders = {
    'Content-type': 'multipart/form-data',
  };
  const key = 'createNewClaim';

  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    FormData,
    CommonResponse,
    CommonResponse
  >({
    params: {
      key,
      method: RequestMethods.POST,
      url: `${AgentEndpoints.AGENTS}/claims/new-claim`,
      request,
      fetchManual: true,
    },
    config: {
      headers,
    },
  });

  const resetQuerryError = useCallback(() => {
    queryClient.resetQueries({ queryKey: [key] });
  }, [queryClient]);

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
    resetQuerryError,
  };
};
